<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="examStructurePropertiesSaveModal"
      size="lg"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm thành phần cấu trúc đề' : 'Cập nhật thành phần cấu trúc đề'"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group label-for="qbQuestionTypeId">
              <template v-slot:label>
                Loại câu hỏi <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Loại câu hỏi"
                rules="required"
              >
                <v-select
                  v-model="targetDataSource.qbQuestionTypeId"
                  :options="qbQuestionTypes"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group label-for="qbQuestionScaleId">
              <template v-slot:label>
                Mức độ câu hỏi <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Mức độ câu hỏi"
                rules="required"
              >
                <v-select
                  v-model="targetDataSource.qbQuestionScaleId"
                  :options="qbQuestionScales"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="numberQuestion">
              <template v-slot:label>
                Số lượng câu hỏi <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Số lượng câu hỏi"
                rules="required"
              >
                <b-form-input
                  id="numberQuestion"
                  type="number"
                  v-model="targetDataSource.numberQuestion"
                  name="numberQuestion"
                  placeholder="Số lượng câu hỏi"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="score">
              <template v-slot:label>
                Điểm cho câu hỏi <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Điểm cho câu hỏi"
                rules="required"
              >
                <b-form-input
                  id="score"
                  type="number"
                  v-model="targetDataSource.score"
                  name="score"
                  placeholder="Điểm cho câu hỏi"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="4"
          >
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetDataSource.status"
                  label="label"
                  :options="statuses"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('examStructurePropertiesSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
        no-wrap
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BModal, BOverlay, BButton, BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { STATUSES } from '@/const/status'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Save',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Cleave,
    vSelect,
    BCol,
    BRow,
    BFormInput,
    ValidationProvider,
    BFormGroup,
    BModal,
    BForm,
    BOverlay,
    BButton,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    qbExamStructureId: {
      type: Number,
      default: null,
    },
    dataForm: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetDataSource: {
        id: null,
        code: '',
        name: '',
        qbExamStructure: null,
        status: 1,
        qbQuestionTypeId: null,
        qbQuestionScaleId: null,
        score: null,
        numberQuestion: null,
        orderNo: 1,
      },
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        status: 1,
      },
      required,
      qbQuestionTypes: [],
      qbQuestionScales: [],
    }
  },
  computed: {
    ...mapGetters({
      qbQuestionTypeData: 'qbQuestionType/dataSources',
      qbQuestionScaleData: 'qbQuestionScale/dataSources',
    }),
    isCreated() {
      return !this.dataForm
    },
    statuses() {
      return STATUSES
    },
  },
  methods: {
    ...mapActions({
      createDataSource: 'qbExamStructureProperties/createDataSource',
      updateDataSource: 'qbExamStructureProperties/updateDataSource',
      getQuestionType: 'qbQuestionType/getDataSources',
      getQuestionScale: 'qbQuestionScale/getDataSources',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      await Promise.all([
        this.getQuestionType(this.filter),
        this.getQuestionScale(this.filter),
      ])
      this.qbQuestionTypes = this.qbQuestionTypeData.map(item => ({
        value: item.id,
        label: item.name,
      }))
      this.qbQuestionScales = this.qbQuestionScaleData.map(item => ({
        value: item.id,
        label: item.name,
      }))
      if (this.dataForm) {
        this.targetDataSource = { ...this.dataForm }
      }
      this.targetDataSource.qbExamStructureId = this.qbExamStructureId
    },
    onHide() {
      this.$refs
        .saveFormRef
        .reset()
      this.targetDataSource = {
        id: null,
        code: '',
        name: '',
        qbExamStructure: null,
        status: 1,
        qbQuestionTypeId: null,
        qbQuestionScaleId: null,
        score: null,
        numberQuestion: null,
        orderNo: 1,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .saveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createDataSource(this.targetDataSource)
            : await this.updateDataSource(this.targetDataSource)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('examStructurePropertiesSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
